import { createFileRoute, redirect } from '@tanstack/react-router'
import { SupplierCreateView } from '@/features/suppliers/suppliers'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/suppliers/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'supplier.create')) {
      throw redirect({ to: '/suppliers' })
    }
  },
  component: SupplierCreateView,
})
